import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
const initialRecipeFilterState = {};
export const RecipeFilterContext = createContext({
    filterState: {},
    setFilterState: () => { },
});
export const RecipeFilterContextProvider = ({ children }) => {
    const [filterState, setFilterState] = useState(initialRecipeFilterState);
    return (_jsx(RecipeFilterContext.Provider, Object.assign({ value: { filterState, setFilterState } }, { children: children })));
};
